import i18next from 'i18next';
import { AffiliateCommissionStatus, PayoutStatus } from '@monorepo/types';
import { AnalyticsTabType, TransactionTabType } from '../types';

export const getStatusTextHelper = (
  status: PayoutStatus | AffiliateCommissionStatus,
): string => {
  const basePath = 'affiliatePortal.dashboard.status';

  switch (status) {
    case PayoutStatus.Pending:
    case AffiliateCommissionStatus.Pending:
      return i18next.t(`${basePath}.pending`, 'Pending');
    case PayoutStatus.Approved:
    case AffiliateCommissionStatus.Approved:
      return i18next.t(`${basePath}.approved`, 'Approved');
    case PayoutStatus.Declined:
      return i18next.t(`${basePath}.declined`, 'Declined');
    case PayoutStatus.Paid:
    case AffiliateCommissionStatus.Paid:
      return i18next.t(`${basePath}.paid`, 'Paid');
    case PayoutStatus.Processing:
      return i18next.t(`${basePath}.processing`, 'Processing');
    case PayoutStatus.Cancelled:
    case AffiliateCommissionStatus.Cancelled:
      return i18next.t(`${basePath}.cancelled`, 'Cancelled');
    case PayoutStatus.Scheduled:
      return i18next.t(`${basePath}.scheduled`, 'Scheduled');
    case PayoutStatus.Sent:
      return i18next.t(`${basePath}.sent`, 'Sent');
    case PayoutStatus.Failed:
      return i18next.t(`${basePath}.failed`, 'Failed');
    default:
      return '';
  }
};

// Helper to get translation key for empty state titles
export function getEmptyStateTitleKey(
  tabType: TransactionTabType | AnalyticsTabType,
): string {
  switch (tabType) {
    case TransactionTabType.COMMISSIONS:
    case AnalyticsTabType.CLICKS:
      return 'affiliatePortal.empty_states.clicks.title';
    case TransactionTabType.HISTORY:
      return 'affiliatePortal.empty_states.payments.title';
    case AnalyticsTabType.REGISTRATION:
    case AnalyticsTabType.CTR:
      return 'affiliatePortal.empty_states.analytics.title';
    default:
      return '';
  }
}

// Helper to get translation key for empty state descriptions
export function getEmptyStateDescriptionKey(
  tabType: TransactionTabType | AnalyticsTabType,
): string {
  switch (tabType) {
    case TransactionTabType.COMMISSIONS:
    case AnalyticsTabType.CLICKS:
      return 'affiliatePortal.empty_states.clicks.description';
    case TransactionTabType.HISTORY:
      return 'affiliatePortal.empty_states.payments.description';
    case AnalyticsTabType.REGISTRATION:
    case AnalyticsTabType.CTR:
      return 'affiliatePortal.empty_states.analytics.description';
    default:
      return '';
  }
}
